import React, { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import { getDocs, collection } from 'firebase/firestore/lite'
import { db } from '../../firebase'
import portfolioData from '../../data/portfolio.json'

const featuredProjects = portfolioData.portfolio

const mergeProjects = (remoteProjects) => {
  const projectsById = new Map()

  remoteProjects.forEach((project) => {
    projectsById.set(project.id || project.name || project.url, project)
  })

  featuredProjects.forEach((project) => {
    projectsById.set(project.id || project.name || project.url, project)
  })

  return Array.from(projectsById.values())
}

const openExternal = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

const Portfolio = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const [portfolio, setPortfolio] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const getPortfolio = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'portfolio'))
        const remoteProjects = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        setPortfolio(mergeProjects(remoteProjects))
      } catch (error) {
        setPortfolio(featuredProjects)
      } finally {
        setIsLoading(false)
      }
    }

    getPortfolio()
  }, [])

  const renderPortfolio = () => {
    if (isLoading) {
      return <p className="portfolio-state">Loading projects...</p>
    }

    if (!portfolio.length) {
      return <p className="portfolio-state">No projects available yet.</p>
    }

    return (
      <div className="images-container">
        {portfolio.map((port, idx) => (
          <div className="image-box" key={port.id || port.url || idx}>
            <img
              src={port.image || port.cover}
              className="portfolio-image"
              alt={port.name || port.title || 'Portfolio project'}
            />
            <div className="content">
              <p className="title">{port.name || port.title}</p>
              <h4 className="description">{port.description}</h4>

              {port.url && (
                <button className="btn" onClick={() => openExternal(port.url)}>
                  View
                </button>
              )}
              {port.playStoreUrl && (
                <button
                  className="btn"
                  onClick={() => openExternal(port.playStoreUrl)}
                >
                  Play Store
                </button>
              )}
              {port.appStoreUrl && (
                <button
                  className="btn"
                  onClick={() => openExternal(port.appStoreUrl)}
                >
                  App Store
                </button>
              )}
              {port.github && (
                <button className="btn" onClick={() => openExternal(port.github)}>
                  Github
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <>
      <div className="container portfolio-page">
        <h1 className="page-title">
          <AnimatedLetters
            letterClass={letterClass}
            strArray={'Portfolio'.split('')}
            idx={15}
          />
        </h1>
        <div>{renderPortfolio()}</div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Portfolio
